import {
  HIDDEN_STATUSES,
  ReportStatus,
  reportStatusTooltips,
  statusTypes,
} from "@/types/typesReportV2";

const receivedTooltip =
  "This report has been received by the police and is awaiting police review.";

export const partnerStatusTypes: { [key in ReportStatus]: string } = {
  ...statusTypes,
  submitted: "Received",
  resubmitted: "Received",
  modification_requested: "Information Requested",
  approved: "Approved",
  rejected: "Rejected",
  escalated: "Escalated",
};

export const partnerStatusTooltips: { [key in ReportStatus]: string } = {
  ...reportStatusTooltips,
  submitted: receivedTooltip,
  resubmitted: receivedTooltip,
  modification_requested:
    "Police have requested more information from the person who submitted the report and are waiting for their response.",
  approved: "Police approved this report and issued a police incident number.",
  rejected:
    "Police rejected this report. No police incident number was issued.",
  escalated:
    "Police escalated this report because it requires an immediate police response.",
};

export const partnerStatusOptions: string[] = (
  Object.keys(partnerStatusTypes) as ReportStatus[]
)
  .filter(
    (status) =>
      !HIDDEN_STATUSES.includes(status) && status !== ReportStatus.resubmitted,
  )
  .sort((a, b) => partnerStatusTypes[a].localeCompare(partnerStatusTypes[b]));

export const partnerStatusQuery = (status: string | null): string | null =>
  status
    ?.split("|")
    .flatMap((s) =>
      s === ReportStatus.submitted ? [s, ReportStatus.resubmitted] : [s],
    )
    .join("|") ?? null;
